import { render, staticRenderFns } from "./childuserlist.vue?vue&type=template&id=0288abd6"
import script from "./childuserlist.vue?vue&type=script&lang=js"
export * from "./childuserlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports